/*
  MC Article — Inhaltsverzeichnis

  Zwei Aufgaben, beide brauchen zwingend JavaScript:

  1. data-offset an den Verzeichnis-Links setzen.
     Warehouse fängt in theme.js jeden Klick auf [href^="#"] ab und scrollt per
     window.scrollTo() auf eine selbst berechnete Position. Bei einem absoluten
     Scrollziel kann scroll-margin-top nicht greifen, die Überschrift landete
     sonst hinter dem Sticky-Header. Der Handler wertet aber data-offset aus.

  2. Den gerade gelesenen Abschnitt hervorheben.
     Die Scrollposition ist in CSS nicht abfragbar.

  Bewusst ohne Abhängigkeiten, ohne Beobachter-API und mit passivem
  Scroll-Listener; die Auswertung läuft gedrosselt über requestAnimationFrame.
*/
(function () {
  var toc = document.querySelector('.mc-article__toc-wrapper');
  if (!toc) return;

  var links = Array.prototype.slice.call(toc.querySelectorAll('.mc-article__toc-link'));
  if (!links.length) return;

  // Nur Links, deren Ziel es auch wirklich gibt
  var entries = [];
  links.forEach(function (link) {
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var target = document.getElementById(href.slice(1));
    if (target) entries.push({ link: link, target: target });
  });

  function headerOffset() {
    var s = getComputedStyle(document.documentElement);
    var h = parseInt(s.getPropertyValue('--header-height'), 10) || 0;
    var sticky = parseInt(s.getPropertyValue('--header-is-sticky'), 10) || 0;
    return h * sticky;
  }

  function applyOffset() {
    var value = headerOffset() + 24;
    links.forEach(function (link) {
      link.setAttribute('data-offset', value);
    });
  }

  var current = null;

  function highlight() {
    if (!entries.length) return;
    // Schwelle etwas unterhalb der Headerkante: der Abschnitt gilt als aktiv,
    // sobald seine Überschrift den oberen Lesebereich erreicht hat.
    var limit = headerOffset() + 80;
    var active = null;

    for (var i = 0; i < entries.length; i++) {
      if (entries[i].target.getBoundingClientRect().top <= limit) {
        active = entries[i];
      }
    }

    // Vor der ersten Überschrift bleibt der erste Eintrag markiert,
    // damit das Verzeichnis nie ganz ohne Markierung dasteht.
    if (!active) active = entries[0];
    if (active === current) return;

    if (current) {
      current.link.classList.remove('is-active');
      current.link.removeAttribute('aria-current');
    }
    active.link.classList.add('is-active');
    active.link.setAttribute('aria-current', 'true');
    current = active;
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      highlight();
      ticking = false;
    });
  }

  applyOffset();
  highlight();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    applyOffset();
    highlight();
  });
  window.addEventListener('load', applyOffset);
})();
